import React, {useState, useContext} from 'react';
import {useNavigate} from 'react-router-dom';
import cover from '../../../../Assets/Images/noskhe-cover.jpg';
import AlbumSong from "./AlbumSong";
import MoreItem from "../MoreItem";
import SimilarProduct from '../SimilarProduct';
import ShareButton from '../ShareButton'
import ReadMore from "../ReadMore";
import MoreProduct from "./MoreProduct";

function AlbumContent(props) {
    const navigate = useNavigate();

    const [album, setAlbum] = useState({
        name: 'نسخه',
        artist: {name: 'هیپاپولوژیست', id: '5'},
        genre: 'رپ',
        dateAdd: '1402/03/01',
        songs: [
            {
                name: 'اینترو',
                link: 'https://dl.solahang.com/Album/1402/04/H/320/01.Hiphopologist%20-%20Intro%20%28320%29.mp3',
                id: 1,
                artistName: 'هیپهاپولوژیست',
                image: 'https://prymie.com/wp-content/uploads/2023/05/IMG_4726-1024x1024.jpg',
                time: '3:25'
            },
            {
                name: 'ادی',
                time: '3:25',
                link: 'https://dl.solahang.com/Album/1402/04/H/320/02.Hiphopologist%20-%20OD%20%28320%29.mp3',
                id: 2,
                artistName: 'هیپهاپولوژیست',
                image: 'https://prymie.com/wp-content/uploads/2023/05/IMG_4726-1024x1024.jpg'
            },
            {
                name: 'سادیسم',
                time: '3:25',
                link: 'https://dl.solahang.com/Album/1402/04/H/320/03.Hiphopologist%20-%20Sadism%20%28320%29.mp3',
                id: 3,
                artistName: 'هیپهاپولوژیست',
                image: 'https://prymie.com/wp-content/uploads/2023/05/IMG_4726-1024x1024.jpg'
            },
            {
                name: 'نورف نورف',
                time: '3:25',
                link: 'https://dl.solahang.com/Album/1402/04/H/320/04.Hiphopologist%20-%20Norf%20Norf%20%28320%29.mp3',
                id: 4,
                artistName: 'هیپهاپولوژیست',
                image: 'https://prymie.com/wp-content/uploads/2023/05/IMG_4726-1024x1024.jpg'
            },
            {
                name: 'دریا کنار',
                time: '3:25',
                link: 'https://dl.solahang.com/Album/1402/04/H/320/05.Hiphopologist%20-%20Daryakenar%20%28320%29.mp3',
                id: 5,
                artistName: 'هیپهاپولوژیست',
                image: 'https://prymie.com/wp-content/uploads/2023/05/IMG_4726-1024x1024.jpg'
            },
            {
                name: 'شیش',
                time: '3:25',
                link: 'https://dl.solahang.com/Album/1402/04/H/320/06.Hiphopologist%20-%20Sheesh%20%28320%29.mp3',
                id: 6,
                artistName: 'هیپهاپولوژیست',
                image: 'https://prymie.com/wp-content/uploads/2023/05/IMG_4726-1024x1024.jpg'
            },
            {
                name: 'آدامس',
                time: '3:25',
                link: 'https://dl.solahang.com/Album/1402/04/H/320/07.Hiphopologist%20%26%20Shayan%20Rag%20-%20Adams%20Skit%20%28320%29.mp3',
                id: 7,
                artistName: 'هیپهاپولوژیست',
                image: 'https://prymie.com/wp-content/uploads/2023/05/IMG_4726-1024x1024.jpg'
            },
            {
                name: 'داستان',
                time: '3:25',
                link: 'https://dl.solahang.com/Album/1402/04/H/320/08.Hiphopologist%20%26%20021Kid%20-%20Dastan%20%28320%29.mp3',
                id: 8,
                artistName: 'هیپهاپولوژیست',
                image: 'https://prymie.com/wp-content/uploads/2023/05/IMG_4726-1024x1024.jpg'
            },
            {
                name: 'بانک',
                time: '3:25',
                link: 'https://dl.solahang.com/Album/1402/04/H/320/09.Hiphopologist%20%26%20Catchy%20Beatz%20-%20Bank%20%28320%29.mp3',
                id: 9,
                artistName: 'هیپهاپولوژیست',
                image: 'https://prymie.com/wp-content/uploads/2023/05/IMG_4726-1024x1024.jpg'
            },
            {
                name: 'یالا',
                time: '3:25',
                link: 'https://dl.solahang.com/Album/1402/04/H/320/10.Hiphopologist%20-%20Yallah%20%28320%29.mp3',
                id: 10,
                artistName: 'هیپهاپولوژیست',
                image: 'https://prymie.com/wp-content/uploads/2023/05/IMG_4726-1024x1024.jpg'
            },
            {
                name: 'ترپ لایف',
                time: '3:25',
                link: 'https://dl.solahang.com/Album/1402/04/H/320/11.Hiphopologist%20%26%20Behzad%20Leito%20-%20Traplife%20%28320%29.mp3',
                id: 11,
                artistName: 'هیپهاپولوژیست',
                image: 'https://prymie.com/wp-content/uploads/2023/05/IMG_4726-1024x1024.jpg'
            },
            {
                name: 'دیاز',
                time: '3:25',
                link: 'https://dl.solahang.com/Album/1402/04/H/320/12.Hiphopologist%20-%20Diaz%20Skit%20%28320%29.mp3',
                id: 12,
                artistName: 'هیپهاپولوژیست',
                image: 'https://prymie.com/wp-content/uploads/2023/05/IMG_4726-1024x1024.jpg'
            },
            {
                name: 'دی ام تی',
                time: '3:25',
                link: 'https://dl.solahang.com/Album/1402/04/H/320/13.Hiphopologist%20-%20DMT%20%28320%29.mp3',
                id: 13,
                artistName: 'هیپهاپولوژیست',
                image: 'https://prymie.com/wp-content/uploads/2023/05/IMG_4726-1024x1024.jpg'
            },
            {
                name: 'با تو',
                time: '3:25',
                link: 'https://dl.solahang.com/Album/1402/04/H/320/15.Hiphopologist%20%26%20Sinazza%20-%20Rotation%20%28320%29.mp3',
                id: 14,
                artistName: 'هیپهاپولوژیست',
                image: 'https://prymie.com/wp-content/uploads/2023/05/IMG_4726-1024x1024.jpg'
            },
            {
                name: 'روتیشن',
                time: '3:25',
                link: 'https://dl.solahang.com/Album/1402/04/H/320/16.Hiphopologist%20%26%20Dehghan%20-%20Bache%20-%20Bad%20B%20%28320%29.mp3',
                id: 15,
                artistName: 'هیپهاپولوژیست',
                image: 'https://prymie.com/wp-content/uploads/2023/05/IMG_4726-1024x1024.jpg'
            },
            {
                name: 'بد بی',
                time: '3:25',
                link: 'https://dl.solahang.com/Album/1402/04/H/320/16.Hiphopologist%20%26%20Dehghan%20-%20Bache%20-%20Bad%20B%20%28320%29.mp3',
                id: 16,
                artistName: 'هیپهاپولوژیست',
                image: 'https://prymie.com/wp-content/uploads/2023/05/IMG_4726-1024x1024.jpg'
            },
            {
                name: 'بچه',
                time: '3:25',
                link: 'https://dl.solahang.com/Album/1402/04/H/320/17.Hiphopologist%20-%20Bache%20%28320%29.mp3',
                id: 17,
                artistName: 'هیپهاپولوژیست',
                image: 'https://prymie.com/wp-content/uploads/2023/05/IMG_4726-1024x1024.jpg'
            },
            {
                name: 'شیر',
                time: '3:25',
                link: 'https://dl.solahang.com/Album/1402/04/H/320/18.Hiphopologist%20-%20Shir%20%28320%29.mp3',
                id: 18,
                artistName: 'هیپهاپولوژیست',
                image: 'https://prymie.com/wp-content/uploads/2023/05/IMG_4726-1024x1024.jpg'
            },
            {
                name: 'ریه',
                time: '3:25',
                link: 'https://dl.solahang.com/Album/1402/04/H/320/19.Hiphopologist%20-%20Rie%20%28320%29.mp3',
                id: 19,
                artistName: 'هیپهاپولوژیست',
                image: 'https://prymie.com/wp-content/uploads/2023/05/IMG_4726-1024x1024.jpg'
            },
        ],
        description: 'لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ، و با استفاده از طراحان گرافیک است، چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است، و برای شرایط فعلی تکنولوژی مورد نیاز، و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد، کتابهای زیادی در شصت و سه درصد گذشته حال و آینده، شناخت فراوان جامعه و متخصصان را می طلبد، تا با نرم افزارها شناخت بیشتری را برای طراحان رایانه ای علی الخصوص طراحان خلاقی، و فرهنگ پیشرو در زبان فارسی ایجاد کرد، در این صورت می توان امید داشت که تمام و دشواری موجود در ارائه راهکارها، و شرایط سخت تایپ به پایان رسد و زمان مورد نیاز شامل حروفچینی دستاوردهای اصلی، و جوابگوی سوالات پیوسته اهل دنیای موجود طراحی اساسا مورد استفاده قرار گیرد.لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ، و با استفاده از طراحان گرافیک است، چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است، و برای شرایط فعلی تکنولوژی مورد نیاز، و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد، کتابهای زیادی در شصت و سه درصد گذشته حال و آینده، شناخت فراوان جامعه و متخصصان را می طلبد، تا با نرم افزارها شناخت بیشتری را برای طراحان رایانه ای علی الخصوص طراحان خلاقی، و فرهنگ پیشرو در زبان فارسی ایجاد کرد، در این صورت می توان امید داشت که تمام و دشواری موجود در ارائه راهکارها، و شرایط سخت تایپ به پایان رسد و زمان مورد نیاز شامل حروفچینی دستاوردهای اصلی، و جوابگوی سوالات پیوسته اهل دنیای موجود طراحی اساسا مورد استفاده قرار گیرد.لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ، و با استفاده از طراحان گرافیک است، چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است، و برای شرایط فعلی تکنولوژی مورد نیاز، و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد، کتابهای زیادی در شصت و سه درصد گذشته حال و آینده، شناخت فراوان جامعه و متخصصان را می طلبد، تا با نرم افزارها شناخت بیشتری را برای طراحان رایانه ای علی الخصوص طراحان خلاقی، و فرهنگ پیشرو در زبان فارسی ایجاد کرد، در این صورت می توان امید داشت که تمام و دشواری موجود در ارائه راهکارها، و شرایط سخت تایپ به پایان رسد و زمان مورد نیاز شامل حروفچینی دستاوردهای اصلی، و جوابگوی سوالات پیوسته اهل دنیای موجود طراحی اساسا مورد استفاده قرار گیرد.',
        creators: [
            {
                name: 'کاگان',
                id: '66',
                artistType: 'آهنگساز',
                image: 'https://www.openthenews.com/wp-content/uploads/2023/03/op2-1.jpg'
            },
            {
                name: 'کاگان',
                id: '66',
                artistType: 'آهنگساز',
                image: 'https://www.openthenews.com/wp-content/uploads/2023/03/op2-1.jpg'
            },
            {
                name: 'کاگان',
                id: '66',
                artistType: 'آهنگساز',
                image: 'https://www.openthenews.com/wp-content/uploads/2023/03/op2-1.jpg'
            },
            {
                name: 'کاگان',
                id: '66',
                artistType: 'آهنگساز',
                image: 'https://www.openthenews.com/wp-content/uploads/2023/03/op2-1.jpg'
            },
            {
                name: 'کاگان',
                id: '66',
                artistType: 'آهنگساز',
                image: 'https://www.openthenews.com/wp-content/uploads/2023/03/op2-1.jpg'
            },
            {
                name: 'کاگان',
                id: '66',
                artistType: 'آهنگساز',
                image: 'https://www.openthenews.com/wp-content/uploads/2023/03/op2-1.jpg'
            },
            {
                name: 'کاگان',
                id: '66',
                artistType: 'آهنگساز',
                image: 'https://www.openthenews.com/wp-content/uploads/2023/03/op2-1.jpg'
            },
            {
                name: 'کاگان',
                id: '66',
                artistType: 'آهنگساز',
                image: 'https://www.openthenews.com/wp-content/uploads/2023/03/op2-1.jpg'
            },
            {
                name: 'کاگان',
                id: '66',
                artistType: 'آهنگساز',
                image: 'https://www.openthenews.com/wp-content/uploads/2023/03/op2-1.jpg'
            },
            {
                name: 'کاگان',
                id: '66',
                artistType: 'آهنگساز',
                image: 'https://www.openthenews.com/wp-content/uploads/2023/03/op2-1.jpg'
            },

        ],
    })
    const [moreProduct, setMoreProduct] = useState([
        {
            name: 'کپسول',
            artist: {name: 'هیپاپولوژیست', id: '5'},
            image: 'https://i1.sndcdn.com/artworks-IyXJUUiehrG7Eljy-jjqIDw-t500x500.jpg'
        },
        {
            name: 'لیک شیت',
            artist: {name: 'هیپاپولوژیست', id: '5'},
            image: 'https://i1.sndcdn.com/artworks-zjTGGPs1G0N4RF2B-kKr9Zg-t500x500.jpg'
        },
        {
            name: 'گیزه',
            artist: {name: 'هیپاپولوژیست', id: '5'},
            image: 'https://i1.sndcdn.com/artworks-vJssdqx6anQgqEzb-uzYpxw-t500x500.jpg'
        },
        {
            name: 'تتپتت',
            artist: {name: 'پوری', id: '5'},
            image: 'https://i1.sndcdn.com/artworks-MalIK9wiErRwZFsN-QmAzBg-t500x500.jpg'
        },
        {
            name: 'انتایتل',
            artist: {name: 'هیپاپولوژیست', id: '5'},
            image: 'https://i1.sndcdn.com/artworks-Tzu6KCxAKsoBujvO-pLwO4g-t240x240.jpg'
        },
        {
            name: 'کپسول2',
            artist: {name: 'هیپاپولوژیست', id: '5'},
            image: 'https://i1.sndcdn.com/artworks-IyXJUUiehrG7Eljy-jjqIDw-t500x500.jpg'
        },
        {
            name: 'لیک شیت2',
            artist: {name: 'هیپاپولوژیست', id: '5'},
            image: 'https://i1.sndcdn.com/artworks-zjTGGPs1G0N4RF2B-kKr9Zg-t500x500.jpg'
        },
        {
            name: 'گیزه2',
            artist: {name: 'هیپاپولوژیست', id: '5'},
            image: 'https://i1.sndcdn.com/artworks-vJssdqx6anQgqEzb-uzYpxw-t500x500.jpg'
        },
        {
            name: 'تتپتت2',
            artist: {name: 'پوری', id: '5'},
            image: 'https://i1.sndcdn.com/artworks-MalIK9wiErRwZFsN-QmAzBg-t500x500.jpg'
        },
        {
            name: 'انتایتل2',
            artist: {name: 'هیپاپولوژیست', id: '5'},
            image: 'https://i1.sndcdn.com/artworks-Tzu6KCxAKsoBujvO-pLwO4g-t240x240.jpg'
        },
        {
            name: 'کپسول3',
            artist: {name: 'هیپاپولوژیست', id: '5'},
            image: 'https://i1.sndcdn.com/artworks-IyXJUUiehrG7Eljy-jjqIDw-t500x500.jpg'
        },
        {
            name: 'لیک شیت3',
            artist: {name: 'هیپاپولوژیست', id: '5'},
            image: 'https://i1.sndcdn.com/artworks-zjTGGPs1G0N4RF2B-kKr9Zg-t500x500.jpg'
        },
        {
            name: 'گیزه3',
            artist: {name: 'هیپاپولوژیست', id: '5'},
            image: 'https://i1.sndcdn.com/artworks-vJssdqx6anQgqEzb-uzYpxw-t500x500.jpg'
        },
        {
            name: 'تتپتت3',
            artist: {name: 'پوری', id: '5'},
            image: 'https://i1.sndcdn.com/artworks-MalIK9wiErRwZFsN-QmAzBg-t500x500.jpg'
        },
        {
            name: 'انتایتل3',
            artist: {name: 'هیپاپولوژیست', id: '5'},
            image: 'https://i1.sndcdn.com/artworks-Tzu6KCxAKsoBujvO-pLwO4g-t240x240.jpg'
        },
    ])
    const [showMoreDescription, setShowMoreDescription] = useState(false)
    const handleShowMoreDescription = () => {
        setShowMoreDescription(!showMoreDescription)
    }

    return (
        <div className='flex flex-col space-y-8 py-4'>
            <div className="flex flex-col space-y-8">
                <div className="flex flex-col md:flex-row items-center mb-4">
                    <img src={cover} alt='cover' className='w-[250px] h-[250px] rounded-xl mb-4 md:ml-8'/>
                    <div className="flex flex-col text-center md:text-right">
                        <div className='text-3xl font-bold mb-4'>{album.name}</div>
                        <div className='text-base text-violet-900 font-bold mb-2 cursor-pointer'
                             onClick={() => navigate('/artist/5')}>{album.artist.name}
                        </div>
                        <div className='text-sm font-medium text-gray-600 mb-2'>{album.genre}</div>
                        <div className='text-sm font-medium text-gray-600 mb-2'>{album.dateAdd}</div>
                        <ShareButton/>
                    </div>
                </div>
                <div className="flex flex-col">
                    <div className="flex flex-row items-center text-violet-700 font-black text-lg md:text-2xl mb-4">
                        توضیحات
                    </div>
                    <ReadMore data={album.description}/>
                </div>
                <div className="flex flex-col">
                    <div className="flex flex-row items-center text-violet-700 font-black text-lg md:text-2xl mb-4">
                        سازندگان
                    </div>
                    <SimilarProduct data={album.creators}/>
                </div>
            </div>
            <div className="flex flex-col space-y-4">
                <div className="flex flex-row items-center text-violet-700 font-black text-lg md:text-2xl mb-4">
                    موزیک های البوم
                </div>
                {
                    album.songs.map((song, index) =>
                        <>
                            <AlbumSong song={song} index={index}/>
                        </>
                    )
                }
            </div>
            <MoreProduct data={moreProduct}/>
        </div>
    );
}

export default AlbumContent;